<ds-comcol-page-header
  [name]="metadataValue.value">
</ds-comcol-page-header>
